import type { BaseLayoutConfig, LayoutRole } from './BaseLayout';

export const layoutConfigs: Record<LayoutRole, BaseLayoutConfig> = {
  admin: {
    headerVariant: 'full',
    headerTitle: 'Dashboard Administrativo',
    showNotifications: true,
    background: 'gray',
    bottomNavRole: 'admin',
  },
  partner: {
    headerVariant: 'hidden',
    showNotifications: true,
    background: 'transparent',
    bottomNavRole: 'partner',
  },
  assessor: {
    headerVariant: 'minimal',
    showNotifications: true,
    background: 'transparent',
    bottomNavRole: 'assessor',
  },
  investor: {
    headerVariant: 'minimal',
    showNotifications: true,
    background: 'transparent',
    bottomNavRole: 'investor',
  },
  incorporador: {
    headerVariant: 'minimal',
    showNotifications: true,
    background: 'transparent',
    bottomNavRole: 'incorporador',
  },
};
